// extracted by mini-css-extract-plugin
export default {"initialName":"initialName__ND2kH"};